import styled from 'styled-components';

import { RadioGroup } from '@dreryk/react-components';

export const StyledPatientDataAccessFormAccessModeField = styled(RadioGroup)`
   align-self: flex-start;
`;
